<template>
  <div
    class="IBadge"
    :class="[
      `IBadge--${type}`,
      size ? `IBadge--${size}` : '',
      isCircle ? `is-circle` : '',
    ]"
  >
    <template v-if="$slots.default">
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: '',
    },
    isCircle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.IBadge {
  @apply tw-px-2.5 tw-py-0.5 tw-rounded-2xl tw-font-normal tw-leading-5 tw-flex-shrink-0 tw-tracking-normal;

  &.is-circle {
    @apply tw-w-5 tw-h-5 tw-p-0 tw-text-xs tw-flex tw-items-center tw-justify-center;
  }

  // Sizes
  &--small {
    @apply tw-text-xs tw-px-1;

    &.is-circle {
      @apply tw-w-4 tw-h-4;
    }
  }

  &--medium {
    @apply tw-px-1;

    &.is-circle {
      @apply tw-text-base tw-leading-5 tw-w-6 tw-h-6;
    }
  }

  &--big {
    @apply tw-px-2;

    &.is-circle {
      @apply tw-text-base tw-leading-5 tw-w-8 tw-h-8;
    }
  }

  // Types
  &--default {
    @apply tw-text-white tw-bg-inactive dark:tw-text-dm-dark dark:tw-bg-dm-light;
  }

  &--primary {
    @apply tw-text-white tw-bg-primary dark:tw-bg-dm-primary;
  }

  &--warning {
    @apply tw-text-white tw-bg-warning;
  }

  &--success {
    @apply tw-text-white tw-bg-success-v2;
  }

  &--white {
    @apply tw-text-primary tw-bg-white;
  }
}
</style>
